import smartBanner from 'smart-app-banner'

import browser from '@/lib/browser'
import { FISH_APP_IDS } from '@/lib/enums'

import { getSmartLink } from '@/lib/purchase-utils'

import fishLogo from '@/assets/images/fish-x-logo.png'
import marketing from '@/lib/marketing'

/** Class responsible for dealing with the smart app banner */
export default class SmartBanner {
  /**
   * @constructor
   */
  constructor() {
    this.head = document.head
    this.iosAppID = null
    this.androidAppID = null

    this.storage = localStorage
    const dismissed = this.storage.getItem('bannerDismissed')

    this.appData = {
      title: '',
      logo: '',
    }

    this.deviceType = this.getDeviceType()

    // Check for a mobile device and that the banner hasn't already been dismissed
    if ((dismissed === 'false' || !dismissed) && this.deviceType !== 'other') {
      this.appendMetaTags()
      this.appendIconLinks()
      this.initializeBanner()
      window.onload = function () {
        window.scrollTo(0, -100)
      }
      this.replaceBannerUrl()
    }
  }

  /**
   * Device type description, included in marketing events
   */
  getDeviceType() {
    if (browser.isAndroid()) {
      return 'android'
    }
    if (browser.isiPhone()) {
      return 'iphone'
    }
    return 'other'
  }

  /**
   * Create the meta tags for the banner and append to the head
   */
  appendMetaTags() {
    this.iosAppID = `app-id=${FISH_APP_IDS.IOS}`
    this.androidAppID = `app-id=${FISH_APP_IDS.ANDROID}`
    this.appData = {
      title: 'onX Fish',
      logo: fishLogo,
    }

    const iosLink = document.createElement('meta')
    iosLink.name = 'apple-itunes-app'
    iosLink.content = this.iosAppID
    this.head.appendChild(iosLink)

    const androidLink = document.createElement('meta')
    androidLink.name = 'google-play-app'
    androidLink.content = this.androidAppID

    this.head.appendChild(androidLink)
  }

  /**
   * Create the icon links for the banner and append to the head
   */
  appendIconLinks() {
    const iosIcon = document.createElement('link')
    iosIcon.rel = 'apple-touch-icon'
    iosIcon.href = this.appData.logo
    this.head.appendChild(iosIcon)

    const androidIcon = document.createElement('link')
    androidIcon.rel = 'android-touch-icon'
    androidIcon.href = this.appData.logo
    this.head.appendChild(androidIcon)
  }

  /**
   * Initialize the banner object
   */
  initializeBanner() {
    new smartBanner({
      daysHidden: 0,
      daysRemaining: 0,
      appStoreLanguage: 'us',
      title: this.appData.title,
      author: 'onX',
      button: 'Open',
      store: {
        ios: 'In the App Store',
        android: 'In Google Play',
      },
      price: {
        ios: 'FREE',
        android: 'FREE',
      },
    })

    marketing.logEvent('smart_banner_viewed', {
      deviceType: this.deviceType,
    })

    const bannerElement = document.body.querySelector('.smartbanner')
    if (bannerElement) {
      // Reset the banner state if displaying - the day timers on the banner
      // object will determine when to display again after being dismissed
      this.storeBannerState(false)

      const close = bannerElement.querySelector('.smartbanner-close')
      close.addEventListener('click', () => {
        marketing.logEvent('smart_banner_dismissed', {
          deviceType: this.deviceType,
        })
        this.storeBannerState(true)
      })

      const view = bannerElement.querySelector('.smartbanner-button')
      view.addEventListener('click', () => {
        marketing.logEvent('smart_banner_clicked', {
          deviceType: this.deviceType,
        })
        this.storeBannerState(true)
      })
    }
  }

  /**
   * Replace the banner link with a smartlink
   */
  replaceBannerUrl() {
    const bannerButton = document.querySelector('.smartbanner-button')

    if (bannerButton) {
      let page = window.location.pathname.slice(1)
      page = page.split('.html')[0]
      bannerButton.href = getSmartLink(page)
    }
  }

  /**
   * Store the dismissed state of the banner to create a better user experience
   *
   * @param {bool} state - whether the banner has been dismissed already or not
   */
  storeBannerState(state) {
    this.storage.setItem('bannerDismissed', state)
  }
}
